module.exports = __webpack_public_path__ + "media/features/mobile-ai-features-c830e012.png";